import { ResponseDto } from '@diritto/common/base/response.dto';
import { RollingReactionType } from '@diritto/common/rolling/constants';
import {
  RollingReactionResponseDto,
  RollingReactionsRequestDto,
  RollingReactionsResponseDto,
} from '@diritto/common/rolling/dtos/rolling-reaction.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class RollingReactionApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getMyReaction(rollingId: number) {
    const res = await this.http.get<RollingReactionResponseDto>(`${this.url}/rollings/${rollingId}/reactions`);
    return res.data;
  }

  async getMyReactions(rollingIds: number[]) {
    const res = await this.http.post<RollingReactionsRequestDto, RollingReactionsResponseDto>(
      `${this.url}/rollings/reactions`,
      {
        rollingIds,
      },
    );
    return res.data;
  }

  async onReaction(rollingId: number, rollingReactionType: RollingReactionType): Promise<ResponseDto> {
    const res = await this.http.post<undefined, ResponseDto>(
      `${this.url}/rollings/${rollingId}/reactions/${rollingReactionType}`,
    );
    return res.data;
  }

  async offReaction(rollingId: number, rollingReactionType: RollingReactionType): Promise<ResponseDto> {
    const res = await this.http.delete<ResponseDto>(
      `${this.url}/rollings/${rollingId}/reactions/${rollingReactionType}`,
    );
    return res.data;
  }

  async onShared(rollingId: number): Promise<ResponseDto> {
    const res = await this.http.post<undefined, ResponseDto>(`${this.url}/rollings/${rollingId}/reactions/shared`);
    return res.data;
  }
}
